<template>
	<section>
		<OverviewSummary :summary="summaryDisplay" class="mb-6" />

		<OverviewKeyTraits :traits="topTraitsDisplay" :wheel-mode="wheelMode" />
	</section>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import OverviewSummary from './OverviewSummary'
import OverviewKeyTraits from './OverviewKeyTraits.vue'

export default {
	name: 'OverviewPanelBase',
	components: {
		OverviewSummary,
		OverviewKeyTraits
	},
	mixins: [personalityResults],
	props: {
		jobOfferData: {
			type: Object,
			default: () => {}
		},
		applicantData: {
			type: Object,
			default: () => {}
		},
		wheelMode: {
			type: String,
			required: true
		}
	}
}
</script>
